package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.team.AnnouncementDto
import com.evoapps.evoshift.data.dto.team.AnnouncementReadDto
import com.evoapps.evoshift.data.dto.team.NewAnnouncementDto
import com.evoapps.evoshift.data.dto.team.ShiftNoteDto
import com.evoapps.evoshift.domain.model.Announcement
import com.evoapps.evoshift.domain.model.AnnouncementRead
import com.evoapps.evoshift.domain.model.ShiftNote

/** SH-118: announcements, read receipts and shift notes between Firestore and the domain. */
object AnnouncementMapper {
    /** The document id wins (older or hand-made documents may lack the field). */
    fun toDomain(dto: AnnouncementDto, id: String, workplaceId: String) = Announcement(
        id = id,
        workplaceId = workplaceId,
        authorId = dto.authorId,
        authorName = dto.authorName?.takeIf { it.isNotBlank() },
        text = dto.text,
        pinned = dto.pinned,
        targetRole = dto.targetRole?.takeIf { it.isNotBlank() },
        createdAt = dto.createdAt,
        recipientCount = dto.recipientCount
    )

    fun toNewDto(announcement: Announcement, id: String) = NewAnnouncementDto(
        id = id,
        workplaceId = announcement.workplaceId,
        authorId = announcement.authorId,
        authorName = announcement.authorName.orEmpty(),
        text = announcement.text,
        pinned = announcement.pinned,
        targetRole = announcement.targetRole,
        createdAt = announcement.createdAt
    )

    fun toDomain(dto: AnnouncementReadDto, id: String) = AnnouncementRead(userId = dto.userId.ifEmpty { id }, readAt = dto.readAt)

    fun toDomain(dto: ShiftNoteDto, id: String, workplaceId: String) = ShiftNote(
        shiftId = dto.shiftId.ifEmpty { id },
        workplaceId = workplaceId,
        userId = dto.userId,
        note = dto.note,
        updatedAt = dto.updatedAt,
        updatedBy = dto.updatedBy
    )

    fun toDto(note: ShiftNote) = ShiftNoteDto(
        shiftId = note.shiftId,
        userId = note.userId,
        note = note.note,
        updatedAt = note.updatedAt,
        updatedBy = note.updatedBy
    )
}
